import {User} from '../zaf';
import {Employee} from '../models/Employee.model';

export const transToEmployee = (obj: User): Employee => (
    {
        employeeNumber: obj.employeeNumber,
        name: obj.name,
        email: obj.email
    }
);

export const dateFormatter = new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
});